import { type QueryClient, queryOptions, useQuery } from '@tanstack/react-query';
import type { PermissionsResponseDTO } from '@tempo-io/id-dto';
import { tempoApi } from '@/lib/api/tempoApi';

export const PERMISSION_DENIED = 'Permission Denied';

export const permissionsQueryOptions = queryOptions({
  queryKey: ['permissions'],
  queryFn: async () => {
    const response = await tempoApi().get('api/permissions/v1');
    return response.json<PermissionsResponseDTO>();
  },
  staleTime: Infinity,
  gcTime: Infinity,
});

export const usePermissions = () => {
  return useQuery(permissionsQueryOptions);
};
export const requireEditOrganizationPermission = async (context: { queryClient: QueryClient }) => {
  const permissions = await context.queryClient.ensureQueryData(permissionsQueryOptions);
  if (!permissions.edit_organization) {
    throw new Error(PERMISSION_DENIED);
  }
};
